
import React, { useState } from 'react';
import { Modal, Form, Input, Button, Select, InputNumber} from 'antd';
import Transactions from '../../logic/transactions';

const ManualTransactionModal = ({ action, accountType, accountId, msisdn }) => {
    const [form] = Form.useForm();
    const [visible, setVisible] = useState(false);
    const [ fetching, setFetching ] = useState(false);
    const [ transactionChannel, setTransactionChannel] = useState('Cash');
    const [ aggregator, setAggregator ] = useState('Disan');
    const [aggregatorReference, setAggregatorReference] = useState('N/A');

    const toggleModal = () => {
        setVisible(!visible);
    };

    const submitTransaction = async () => {
        setFetching(true);
        await form.validateFields().then(async values => {
            let transactionData = {
                account: accountId,
                amount: values.amount,
                transaction_type: action,
                transaction_channel: values.transactionChannel,
                transaction_source: 'disan',
                msisdn: msisdn,
                description: values.description,
                manual_transaction: "true",
                manual_transaction_date: values.transactionDate,
                aggregator: aggregator,
                aggregator_reference: aggregatorReference,
            }
            await new Transactions(transactionData).create();
            // form.resetFields();
            setFetching(false);
            setVisible(false);
        });
        setFetching(false);
    }

    return (
        <>
            <Button onClick={toggleModal} style={{margin: '2px', color: action === 'Deposit' ? 'green' : 'black'}}>{`${action.substring(0,3)}.`}</Button>
            <Modal
                open={visible}
                title={`${action} ${action === 'Deposit' ? 'to' : 'from'} ${accountType} Account`}
                onCancel={()=>{form.resetFields(); setVisible(false)}}
                onOk={submitTransaction}
                okText={action}
                okButtonProps={{loading: fetching, disabled: fetching}}
                cancelButtonProps={{disabled: fetching}}
            >
                <Form form={form} layout="vertical">
                    <Form.Item
                        name="transactionChannel"
                        label="Channel"
                        rules={[
                            {
                                required: true,
                                message: 'Please select the channel of the transaction',
                            },
                        ]}
                    >
                        <Select
                            placeholder="Select a channel" 
                            value={transactionChannel} 
                            onChange={(value) => {setTransactionChannel(value)}}>
                            <Select.Option value="Bank">Bank</Select.Option>
                            <Select.Option value="Cash">Cash</Select.Option>
                            <Select.Option value="Mobile Money">Mobile Money</Select.Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="amount"
                        label="Amount"
                        rules={[
                            {
                                required: true,
                                message: 'Please input the new pin',
                            },
                        ]}
                    >
                        <InputNumber
                            defaultValue={1000}
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            style={{width: '100%'}}
                            />
                    </Form.Item>

                    <Form.Item
                        name="transactionDate"
                        label="Date of transaction"
                        rules={[
                            {
                                required: true,
                                message: 'Please select the date of the transaction',
                            },
                        ]}
                    >
                        <Input type="date"/>
                    </Form.Item>

                    {/* only show if the transaction channel is momo */}
                    {
                        transactionChannel === 'Mobile Money' ?
                        <React.Fragment>
                            <Form.Item
                                name="aggregator"
                                label="Aggregator"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please select the aggregator for this transaction',
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Select the aggregator" 
                                    value={aggregator} 
                                    onChange={(value) => {setAggregator(value)}}>
                                    <Select.Option value="Disan">Disan</Select.Option>
                                    <Select.Option value="Beyonic">Beyonic</Select.Option>
                                </Select>
                            </Form.Item>

                            <Form.Item
                                name="aggregatorReference"
                                label="Aggregator Reference"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please enter the aggregator reference',
                                    },
                                ]}
                            >
                                <Input onChange={(e)=>{ setAggregatorReference(e.target.value)}} />
                            </Form.Item>

                        </React.Fragment>
                        :
                        null
                    }

                    <Form.Item
                        name="description"
                        label="Reason"
                        rules={[
                            {
                                required: true,
                                message: 'Please provide a description for this transaction',
                            },
                        ]}
                    >
                        <Input.TextArea rows={3} />
                    </Form.Item>

                </Form>
            </Modal>
        </>
    );
};

export default ManualTransactionModal;
